import { addHours, format, parse } from "date-fns";

export function addHoursToTimeString(timeString: string, hours: number): string {
  // Parse the time string into a Date object
  const date = parse(timeString, "HH:mm", new Date());

  // Add one hour
  const newDate = addHours(date, hours);

  // Format the new date back to a string
  return format(newDate, "HH:mm");
}

export const parseTime = (time: string) => {
  let [hours, minutes] = time.replaceAll("AM", "").replaceAll("PM", "").split(":").map(Number);

  if (time.toLowerCase().includes("pm") && hours !== 12) {
    return [hours + 12, minutes];
  } else if (time.toLowerCase().includes("am") && hours === 12) {
    return [0, minutes];
  }

  return [hours, minutes];
};
